var _circle, _circle2, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDisccord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear_16_2384)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#37364D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9891 9.71146C12.1145 9.71146 10.0987 10.9176 10.0987 10.9176C11.2041 9.95269 13.1328 9.39612 13.1328 9.39612L12.9508 9.21796C11.138 9.24949 9.49769 10.4777 9.49769 10.4777C7.65433 14.2444 7.77195 17.4971 7.77195 17.4971C9.27371 19.3954 11.5038 19.2598 11.5038 19.2598L12.2659 18.3154C10.9253 18.0316 10.0778 16.868 10.0778 16.868C10.0778 16.868 12.0935 18.2113 14.9891 18.2113C17.8847 18.2113 19.9004 16.868 19.9004 16.868C19.9004 16.868 19.0529 18.0331 17.7122 18.3154L18.4744 19.2598C18.4744 19.2598 20.7045 19.397 22.2062 17.4971C22.2062 17.4971 22.3239 14.2444 20.4789 10.4777C20.4789 10.4777 18.8386 9.24949 17.0258 9.21796L16.8437 9.39612C16.8437 9.39612 18.7741 9.95269 19.8779 10.9176C19.8795 10.9176 17.8637 9.71146 14.9891 9.71146ZM12.7703 13.6878C13.468 13.6878 14.0352 14.2854 14.0255 15.0201C14.0255 15.7438 13.468 16.3524 12.7703 16.3524C12.0839 16.3524 11.5263 15.7438 11.5263 15.0201C11.5263 14.2854 12.0726 13.6878 12.7703 13.6878ZM17.2417 13.6878C17.9394 13.6878 18.497 14.2854 18.497 15.0201C18.497 15.7438 17.9394 16.3524 17.2417 16.3524C16.5553 16.3524 15.9978 15.7438 15.9978 15.0201C15.9978 14.2854 16.544 13.6878 17.2417 13.6878Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_2384",
    x1: 4.32655e-7,
    y1: -7.00002,
    x2: 31.6843,
    y2: -6.25984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11632,
    stopColor: "#2698EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527778,
    stopColor: "#FFB176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983091,
    stopColor: "#ED5158"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDisccord);
export default __webpack_public_path__ + "static/media/icon_disccord.77ef8b210fb0ae499666e5ce284e405e.svg";
export { ForwardRef as ReactComponent };